import React from "react";
import cx from "classnames";
import type { LinearProgressProps, Theme } from "@material-ui/core";
import { LinearProgress, makeStyles } from "@material-ui/core";
import type { IResponseWithLoadingAndTimestamp } from "App/Modules/Models";

export type LoadingProps = IResponseWithLoadingAndTimestamp<void> & {
    keepMounted?: boolean;
} & LinearProgressProps;

const useStyles = makeStyles((theme: Theme) => ({
    progressBarError: {
        "& .MuiLinearProgress-bar": {
            backgroundColor: theme.palette.error.main,
        },
    },
}));

export const Loading = (props: LoadingProps) => {
    const classes = useStyles();

    const {
        error,
        isLoading,
        isPartiallyLoading,
        isSuccessful,
        isPartiallySuccessful,
        hasError,
        hasPartialError,
        data,
        keepMounted,
        xhrStatus,
        statusText,
        status,
        headers,
        dtLastUpdated,
        className,
        ...progressProps
    } = props;

    const barClassName = cx(
        className,
        !isLoading && !isPartiallyLoading && (hasError || hasPartialError) && classes.progressBarError,
    );

    if (!isLoading && !isPartiallyLoading && (hasError || hasPartialError)) {
        progressProps.variant = "determinate";
        progressProps.value = 100;
    } else if (!isLoading && !isPartiallyLoading) {
        progressProps.style = {
            ...progressProps.style,
            visibility: "hidden",
        };
    }

    return (keepMounted || isLoading) && <LinearProgress {...progressProps} className={barClassName} />;
};
